<template>
  <section class="panel">
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="open()">新增活动</el-button>
      <el-button class="btn-refresh" icon="el-icon-refresh" @click="load">刷新</el-button>
    </div>
    <el-table :data="page.records" border size="small">
      <el-table-column prop="title" label="标题" min-width="180" />
      <el-table-column prop="coverUrl" label="封面" width="90">
        <template slot-scope="{ row }">
          <el-image v-if="row.coverUrl" :src="absolute(row.coverUrl)" style="width:48px;height:36px" fit="cover" />
        </template>
      </el-table-column>
      <el-table-column label="状态" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 'PUBLISHED' ? 'success' : 'info'" size="small">
            {{ statusText(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="开始时间" width="170" />
      <el-table-column prop="endTime" label="结束时间" width="170" />
      <el-table-column label="操作" width="210">
        <template slot-scope="{ row }">
          <el-button size="mini" class="btn-edit" @click="open(row)">编辑</el-button>
          <el-button size="mini" :type="row.status === 'PUBLISHED' ? 'warning' : 'success'" @click="setStatus(row)">{{ row.status === 'PUBLISHED' ? '下架' : '发布' }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :current-page="query.page"
      :page-size="query.size"
      :page-sizes="[10, 20, 50, 100]"
      :total="page.total"
      @size-change="size => { query.size = size; query.page = 1; load() }"
      @current-change="p => { query.page = p; load() }"
    />

    <el-dialog :title="form.id ? '编辑活动' : '新增活动'" :visible.sync="dialog" width="680px">
      <el-form label-position="top">
        <el-form-item label="标题"><el-input v-model="form.title" /></el-form-item>
        <el-form-item label="封面"><image-upload v-model="form.coverUrl" :file-id.sync="form.coverFileId" biz-type="activity" /></el-form-item>
        <el-form-item label="海报"><image-upload v-model="form.posterUrl" :file-id.sync="form.posterFileId" biz-type="activity" /></el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="form.startTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择开始时间"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="form.endTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择结束时间"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="内容">
          <rich-text-editor
            v-model="form.content"
            placeholder="请输入活动图文内容，可插入图片、表格、链接等"
            biz-type="activity-content"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import http, { absoluteUrl } from '../api'
import ImageUpload from '../components/ImageUpload.vue'
import RichTextEditor from '../components/RichTextEditor.vue'

const blankPage = { total: 0, page: 1, size: 10, records: [] }
const activityStatusText = { PUBLISHED: '已发布', DRAFT: '草稿' }

export default {
  components: { ImageUpload, RichTextEditor },
  data() {
    return {
      query: { page: 1, size: 10 },
      page: { ...blankPage },
      dialog: false,
      form: {}
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    absolute: absoluteUrl,
    statusText(status) {
      return activityStatusText[status] || status || '-'
    },
    async load() {
      this.page = await http.get('/admin/activities', { params: this.query })
    },
    open(row) {
      this.form = row ? { ...row } : { status: 'DRAFT', sort: 100 }
      this.dialog = true
    },
    async save() {
      if (this.form.id) {
        await http.put(`/admin/activities/${this.form.id}`, this.form)
      } else {
        await http.post('/admin/activities', this.form)
      }
      this.dialog = false
      this.load()
    },
    async setStatus(row) {
      await http.put(`/admin/activities/${row.id}/status`, { status: row.status === 'PUBLISHED' ? 'DRAFT' : 'PUBLISHED' })
      this.load()
    }
  }
}
</script>
